import { useEffect, useState } from 'react';
import { useWindowSize } from './useWindowSize';

export const useShowResponsiveBanner = (widthBoundary: number): boolean => {
  const windowSize = useWindowSize();

  const [showResponsiveBanner, setShowResponsiveBanner] = useState(false);

  useEffect(() => {
    if (!windowSize.width) {
      return;
    }

    if (windowSize?.width < widthBoundary && !showResponsiveBanner) {
      setShowResponsiveBanner(true);
    }
    if (windowSize?.width > widthBoundary && showResponsiveBanner) {
      setShowResponsiveBanner(false);
    }
  }, [windowSize?.width]);

  return showResponsiveBanner;
};
